export default "__VITE_ASSET__BOhGktaZ__"